import API from 'js/lib/api';

export default API('/api/carts.v2', {
  type: 'rest',
});
